export default __webpack_public_path__ + "static/media/image5.08f0fd7f.png";